module.exports = __webpack_public_path__ + "static/digitalocean-6a33ddf68426f6dec5efed56fc4089c9.svg";